import { type FunctionComponent } from 'react';
import cx from 'classnames';

import { carouselCardContent } from './carouselCardContent';

import styles from './CarouselCard.less';

interface CarouselCardProps {
  cardType: 'board' | 'inbox' | 'planner';
}

export const CarouselCard: FunctionComponent<CarouselCardProps> = ({
  cardType,
}) => {
  const { title, body, image, className } = carouselCardContent[cardType];

  return (
    <div className={cx(styles.card, className)}>
      <h1>{title}</h1>
      <p>{body}</p>
      <img src={image} alt={`${title} card content`} />
    </div>
  );
};
